export default "__VITE_ASSET__BgZKp$dG__"